import { env } from "../appConfig";

const RELAY_HEADERS = {
  "Content-Type": "application/json; charset=UTF-8",
  "cache-control": "no-cache",
};

function getRelayServiceUrl() {
  const url = env.RELAY_SERVICE;
  if (!url) {
    throw new Error("Missing required environment variable: RELAY_SERVICE");
  }
  return url;
}

export function buildRelayUrl(forwardUrl) {
  return `${getRelayServiceUrl()}?forwardUrl=${forwardUrl}`;
}

export async function relayFetch(forwardUrl, options = {}) {
  return fetch(buildRelayUrl(forwardUrl), {
    ...options,
    headers: {
      ...RELAY_HEADERS,
      ...(options.headers || {}),
    },
  });
}

export async function relayFetchJson(forwardUrl, options = {}) {
  const response = await relayFetch(forwardUrl, options);
  const data = await response.json().catch(() => ({}));
  return { response, data };
}

export async function relayFetchText(forwardUrl, options = {}) {
  const response = await relayFetch(forwardUrl, options);
  const text = await response.text();
  return { response, text };
}
